module.exports = __webpack_public_path__ + "img/-LV18_yti_8Tr_axiLEz.f374e7b7.jpg";